import React from "react";
import styles from "./WorksEverywhere.module.scss"
import Image from "next/image";
function WorksEverywhere() {
  return (
    <section className={styles.worksEverywhere}>
      <div className={styles.container}>
        <div className={styles.sectionHeader}>
          <h2>Works Everywhere</h2>
          <p>
            Deploy across all platforms and devices for a truly omnichannel
            experience.
          </p>
        </div>
        <div className={styles.platformsGrid}>
          <div className={styles.platformCard}>
            <div className={styles.platformIcon}>
              {/* <Globe size={20} /> */}
              <Image
                  src="/agent-icons/globe.svg"
                  alt="AI Agents"
                  width={20}
                  height={20}
                  className={styles.whiteIcon}
                />
            </div>
            <h3>Web</h3>
            <p>Full-featured web experience</p>
          </div>

          <div className={styles.platformCard}>
            <div className={styles.platformIcon}>
              {/* <Smartphone size={20} /> */}
              <Image
                  src="/agent-icons/phone.svg"
                  alt="AI Agents"
                  width={20}
                  height={20}
                  className={styles.whiteIcon}
                />
            </div>
            <h3>Mobile</h3>
            <p>iOS & Android Apps</p>
          </div>

          <div className={styles.platformCard}>
            <div className={styles.platformIcon}>
              {/* <Tablet size={20} /> */}
              <Image
                  src="/agent-icons/phone.svg"
                  alt="AI Agents"
                  width={20}
                  height={20}
                  className={styles.whiteIcon}
                />
            </div>
            <h3>Tablet</h3>
            <p>Tablet Optimized</p>
          </div>

          <div className={styles.platformCard}>
            <div className={styles.platformIcon}>
              {/* <Monitor size={20} /> */}
              <Image
                  src="/agent-icons/web.svg"
                  alt="AI Agents"
                  width={20}
                  height={20}
                  className={styles.whiteIcon}
                />
            </div>
            <h3>API</h3>
            <p>Integrate with any platform</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WorksEverywhere;
